export const SIZE = 160;
export const MAX_VALUE_ELEMENTS = 4;
